import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/Card';
import { BoxIcon } from 'lucide-react';
interface ToolCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  href: string;
}
export function ToolCard({
  title,
  description,
  icon: Icon,
  href
}: ToolCardProps) {
  return <Link to={href} className="block group" data-id="element-111">
      <Card className="h-full transition-all hover:shadow-md hover:border-primary/50" data-id="element-112">
        <CardHeader data-id="element-113">
          <div className="flex items-start gap-4" data-id="element-114">
            <div className="p-2 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors" data-id="element-115">
              <Icon className="w-6 h-6" data-id="element-116" />
            </div>
            <div className="flex-1" data-id="element-117">
              <CardTitle className="text-lg" data-id="element-118">{title}</CardTitle>
              <CardDescription data-id="element-119">{description}</CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>
    </Link>;
}